// PAGES
import Accueil from '@/pages/Accueil';
import Bingo from '@/pages/Bingo';
import Casino from '@/pages/Casino';
import Compte from '@/pages/Compte';
import RedirectionLangue from '@/pages/RedirectionLangue';
import SansMenu from '@/pages/SansMenu';

// BASE (ordre alphabétique)
import AireTexte from '@/components/base/AireTexte';
import Bandeau from '@/components/base/bandeau/Bandeau';
import BanniereLaterale from '@/components/base/BanniereLaterale';
import BoutonImage from '@/components/base/BoutonImage';
import BoutonSignUp from '@/components/base/BoutonSignUp.vue';
import CarteCasinoGrosLot from '@/components/base/carte/CarteCasinoGrosLot';
import CarteLoterieGrosLot from '@/components/base/carte/CarteLoterieGrosLot';
import CarteObsolete from '@/components/base/CarteObsolete';
import CarteOffreBienvenue from '@/components/base/carte/CarteOffreBienvenue';
import CartePromo from '@/components/base/carte/CartePromo';
import Catfish from '@/components/base/Catfish';
import ChangerLangue from '@/components/base/ChangerLangue';
import CodeHTML from '@/components/base/CodeHTML';
import ConfigurationOrdinateur from '@/components/base/ConfigurationOrdinateur';
import Faq from '@/components/base/Faq';
import Hyperlien from '@/components/base/Hyperlien';
import IframeHtml from '@/components/base/IframeHtml';
import IframeHtmlSalesforce from '@/components/base/IframeHtmlSalesforce';
import InfoTitre from '@/components/base/InfoTitre';
import LienRetour from '@/components/base/LienRetour';
import Menu from '@/components/base/Menu';
import MenuBas from '@/components/base/MenuBas';
import MenuGauche from '@/components/base/MenuGauche';
import MenuNavigation from '@/components/base/MenuNavigation';
import MenuPage from '@/components/base/MenuPage';
import MenuPiedDePage from '@/components/base/MenuPiedDePage';
import MenuPromotions from '@/components/base/MenuPromotions';
import MessageMel from '@/components/base/MessageMel';
import Message from '@/components/base/Message';
import Notification from '@/components/base/Notification';
import Paragraphe from '@/components/base/Paragraphe';
import Separateur from '@/components/base/Separateur';
import Tableau from '@/components/base/Tableau';
import Titre from '@/components/base/Titre';
import TitrePromotions from '@/components/base/TitrePromotions';
import ZoneEscamotable from '@/components/base/ZoneEscamotable';
import ZoneEscamotableMiseAvant from '@/components/base/ZoneEscamotableMiseAvant';

// BIENJOUER
import PanelItem from '@/components/compte/bienJouer/PanelItem';
import PeriodPanels from '@/components/compte/bienJouer/PeriodPanels';
import LimitForm from '@/components/compte/bienJouer/LimitForm';
import LimitSection from '@/components/compte/bienJouer/LimitSection';

// BINGO
import BingoEntete from '@/components/bingo/BingoEntete';
import BingoGagnantMajeur from '@/components/bingo/BingoGagnantMajeur';
import BingoGagnantMajeurListe from '@/components/bingo/BingoGagnantMajeurListe';
import BingoJeu from '@/components/bingo/BingoJeu';
import BingoSalle from '@/components/bingo/BingoSalle';
import BingoMediaImage from '@/components/bingo/media/image/MediaImage';

// CASINO
import CarteListeProduitCasino from '@/components/casino/carte/CarteListeProduitCasino';
import CarteListeProduitCED from '@/components/casino/carte/CarteListeProduitCED';
import CarteProduitCasino from '@/components/casino/carte/CarteProduitCasino';
import CarteProduitCED from '@/components/casino/carte/CarteProduitCED';
import CollectionCasino from '@/components/casino/CollectionCasino';
import CollectionCasinoListe from '@/components/casino/CollectionCasinoListe';
import JeuCasino from '@/components/casino/jeu/JeuCasino';
import MediaImageLogoProduitCasino3x4 from '@/components/casino/media/image/MediaImageLogoProduitCasino3x4';
import MediaImageLogoProduitCasinoLarge from '@/components/casino/media/image/MediaImageLogoProduitCasinoLarge';
import ModaleNewsletter from '@/components/casino/modals/ModaleNewsletter';

// CONTAINER
import Row from '@/components/container/grid/Row';
import Column from '@/components/container/grid/Column';
import BlocEditable from '@/components/container/grid/BlocEditable';
import GroupeCarte from '@/components/container/carte/GroupeCarte';
import ListeCatfish from '@/components/container/liste/ListeCatfish';
import ListeHorizontale from '@/components/container/liste/ListeHorizontale';
import ListeNotifications from '@/components/container/liste/ListeNotifications';
import ListeLiens from '@/components/container/liste/ListeLiens';
import SectionLiens from '@/components/container/liste/SectionLiens';
import EntetePage from '@/components/container/entete/EntetePage';
import EnteteSection from '@/components/container/entete/EnteteSection';
import GrandeSection from '@/components/container/entete/GrandeSection';

// FORMULAIRE (ordre alphabétique)
import Formulaire from '@/components/formulaire/Formulaire';
import FormulaireBilletterieSalesforce from '@/components/formulaire/FormulaireBilletterieSalesforce';
import FormulaireGroupeRadio from '@/components/formulaire/base/GroupeRadio';
import FormulaireListeChoix from '@/components/formulaire/base/ListeChoix';
import FormulaireRadioComboFiltre from '@/components/formulaire/base/RadioComboFiltre';
import FormulaireAdresse from '@/components/formulaire/compte/Adresse';
import FormulaireCanafe from '@/components/formulaire/compte/Canafe';
import FormulaireCodePostal from '@/components/formulaire/compte/CodePostal';
import FormulaireConfirmationCanafe from '@/components/formulaire/compte/ConfirmationCanafe';
import FormulaireCourriel from '@/components/formulaire/compte/Courriel';
import FormulaireDateDeNaissance from '@/components/formulaire/compte/DateDeNaissance';
import FormulaireDepot from '@/components/formulaire/compte/Depot';
import FormulaireGenre from '@/components/formulaire/compte/Genre';
import FormulaireIdentiteVerification from '@/components/formulaire/compte/IdentiteVerification';
import FormulaireLimiteDepot from '@/components/formulaire/compte/LimiteDepot';
import FormulaireMotDePasse from '@/components/formulaire/compte/MotDePasse';
import FormulaireNomUtilisateur from '@/components/formulaire/compte/NomUtilisateur';
import FormulaireOffreBienvenue from '@/components/formulaire/compte/OffreBienvenue';
import FormulairePrenomNom from '@/components/formulaire/compte/PrenomNom';
import FormulaireProfession from '@/components/formulaire/compte/Profession';
import FormulaireRecevoirCommunication from '@/components/formulaire/compte/RecevoirCommunication';
import FormulaireSecuriteMotDePasse from '@/components/formulaire/compte/SecuriteMotDePasse';
import FormulaireSecuriteVerification from '@/components/formulaire/compte/SecuriteVerification';
import FormulaireTelephone from '@/components/formulaire/compte/Telephone';
import FormulaireTeleverserPieceIdentite from '@/components/formulaire/compte/TeleverserPieceIdentite';

// HERITAGE (ordre alphabétique)
import Heritage from '@/components/base/Heritage';

// MEDIAIMAGE (ordre alphabétique)
import MediaImage from '@/components/media/image/MediaImage';
import MediaImageFocalPoint from '@/components/media/image/MediaImageFocalPoint';
import MediaImageLogo from '@/components/media/image/MediaImageLogo';
import MediaImageX3 from '@/components/media/image/MediaImageX3';

// Compte (ordre alphabétique)
import CompteActiviteJeux from '@/components/compte/ActiviteJeux';
import CompteAvisBienJouer from '@/components/compte/AvisBienJouer';
import CompteCasinoPrivilegesAppariement from '@/components/compte/CasinoPrivilegesAppariement';
import CompteEnteteInfosPersonnelles from '@/components/compte/EnteteInfosPersonnelles';
import CompteInfoPersonnelle from '@/components/compte/InfoPersonnelle';
import CompteNotificationsBienJouer from '@/components/compte/NotificationsBienJouer';
import CompteLimitesBienJouer from '@/components/compte/LimitesBienJouer';
import CompteTitreSolde from '@/components/compte/TitreSolde';

// PROMO (ordre alphabétique)
import Promo from '@/components/promo/Promo';
import PromoDetail from '@/components/promo/PromoDetail';

// PRODUIT
import ProduitCollection from '@/components/produit/ProduitCollection';

// AUTH0
import Auth0Error from '@/components/auth0/Error';
import Auth0MfaResetPassword from '@/components/auth0/MfaResetPassword';

const config = {
  componentMappings: {
    // Pages
    'jel-lm:pages/accueil': Accueil,
    'jel-lm:pages/bingo': Bingo,
    'jel-lm:pages/casino': Casino,
    'jel-lm:pages/compte': Compte,
    'jel-lm:pages/redirectionLangue': RedirectionLangue,
    'jel-lm:pages/sansMenu': SansMenu,

    // BASE (ordre alphabétique)
    'jel-lm:components/base/aireTexte': AireTexte,
    'jel-lm:components/base/bandeau': Bandeau,
    'jel-lm:components/base/banniereLaterale': BanniereLaterale,
    'jel-lm:components/base/boutonImage': BoutonImage,
    'jel-lm:components/base/boutonSignUp': BoutonSignUp,
    'jel-lm:components/base/carte': CarteObsolete,
    'jel-lm:components/base/carte/carteCasinoGrosLot': CarteCasinoGrosLot,
    'jel-lm:components/base/carte/carteLoterieGrosLot': CarteLoterieGrosLot,
    'jel-lm:components/base/carte/carteOffreBienvenue': CarteOffreBienvenue,
    'jel-lm:components/base/carte/cartePromo': CartePromo,
    'jel-lm:components/base/catfish': Catfish,
    'jel-lm:components/base/changerLangue': ChangerLangue,
    'jel-lm:components/base/codeHTML': CodeHTML,
    'jel-lm:components/base/configurationOrdinateur': ConfigurationOrdinateur,
    'jel-lm:components/base/faq': Faq,
    'jel-lm:components/base/hyperlien': Hyperlien,
    'jel-lm:components/base/iframeHtml': IframeHtml,
    'jel-lm:components/base/IframeHtmlSalesforce': IframeHtmlSalesforce,
    'jel-lm:components/base/infoTitre': InfoTitre,
    'jel-lm:components/base/lienRetour': LienRetour,
    'jel-lm:components/base/menu': Menu,
    'jel-lm:components/base/menuBas': MenuBas,
    'jel-lm:components/base/menuGauche': MenuGauche,
    'jel-lm:components/base/menuNavigation': MenuNavigation,
    'jel-lm:components/base/menuPage': MenuPage,
    'jel-lm:components/base/menuPiedDePage': MenuPiedDePage,
    'jel-lm:components/base/menuPromotions': MenuPromotions,
    'jel-lm:components/base/messageMel': MessageMel,
    'jel-lm:components/base/message': Message,
    'jel-lm:components/base/notification': Notification,
    'jel-lm:components/base/paragraphe': Paragraphe,
    'jel-lm:components/base/separateur': Separateur,
    'jel-lm:components/base/tableau': Tableau,
    'jel-lm:components/base/titre': Titre,
    'jel-lm:components/base/titrePromotions': TitrePromotions,
    'jel-lm:components/base/zoneEscamotable': ZoneEscamotable,
    'jel-lm:components/base/zoneEscamotableMiseAvant': ZoneEscamotableMiseAvant,

    // BIENJOUER
    'jel-lm:components/compte/bienJouer/panelItem': PanelItem,
    'jel-lm:components/compte/bienJouer/periodPanels': PeriodPanels,
    'jel-lm:components/compte/bienJouer/limitForm': LimitForm,
    'jel-lm:components/compte/bienJouer/limitSection': LimitSection,

    // Bingo
    'jel-lm:components/bingo/entete': BingoEntete,
    'jel-lm:components/bingo/bingoGagnantMajeur': BingoGagnantMajeur,
    'jel-lm:components/bingo/bingoGagnantMajeurListe': BingoGagnantMajeurListe,
    'jel-lm:components/bingo/bingoJeu': BingoJeu,
    'jel-lm:components/bingo/bingoSalle': BingoSalle,
    'jel-lm:components/bingo/media/image': BingoMediaImage,

    // Casino
    'jel-lm:components/casino/carte/carteListeProduitCasino': CarteListeProduitCasino,
    'jel-lm:components/casino/carte/carteListeProduitCED': CarteListeProduitCED,
    'jel-lm:components/casino/carte/carteProduitCasino': CarteProduitCasino,
    'jel-lm:components/casino/carte/carteProduitCED': CarteProduitCED,
    'jel-lm:components/casino/collectionCasino': CollectionCasino,
    'jel-lm:components/casino/collectionCasinoListe': CollectionCasinoListe,
    'jel-lm:components/casino/jeu/jeuCasino': JeuCasino,
    'jel-lm:components/casino/media/image/mediaImageLogoProduitCasino3x4':
      MediaImageLogoProduitCasino3x4,
    'jel-lm:components/casino/media/image/mediaImageLogoProduitCasinoLarge':
      MediaImageLogoProduitCasinoLarge,
    'jel-lm:components/casino/modals/modalNewsletter': ModaleNewsletter,

    // Container
    'jel-lm:components/container/grid/row': Row,
    'jel-lm:components/container/grid/column': Column,
    'jel-lm:components/container/grid/blocEditable': BlocEditable,
    'jel-lm:components/container/carte/groupeCarte': GroupeCarte,
    'jel-lm:components/container/liste/listeCatfish': ListeCatfish,
    'jel-lm:components/container/liste/listeHorizontale': ListeHorizontale,
    'jel-lm:components/container/liste/listeNotifications': ListeNotifications,
    'jel-lm:components/container/liste/listeLiens': ListeLiens,
    'jel-lm:components/container/liste/sectionLiens': SectionLiens,
    'jel-lm:components/container/entete/entetePage': EntetePage,
    'jel-lm:components/container/entete/enteteSection': EnteteSection,
    'jel-lm:components/container/entete/grandeSection': GrandeSection,

    // Heritage
    'jel-lm:components/base/heritage': Heritage,

    // FORMULAIRE (ordre alphabétique)
    'jel-lm:components/formulaire/formulaire': Formulaire,
    'jel-lm:components/formulaire/formulaireBilletterieSalesforce': FormulaireBilletterieSalesforce,
    'jel-lm:components/formulaire/base/groupeRadio': FormulaireGroupeRadio,
    'jel-lm:components/formulaire/base/listeChoix': FormulaireListeChoix,
    'jel-lm:components/formulaire/base/radioComboFiltre': FormulaireRadioComboFiltre,
    'jel-lm:components/formulaire/compte/adresse': FormulaireAdresse,
    'jel-lm:components/formulaire/compte/canafe': FormulaireCanafe,
    'jel-lm:components/formulaire/compte/codePostal': FormulaireCodePostal,
    'jel-lm:components/formulaire/compte/confirmationCanafe': FormulaireConfirmationCanafe,
    'jel-lm:components/formulaire/compte/courriel': FormulaireCourriel,
    'jel-lm:components/formulaire/compte/dateDeNaissance': FormulaireDateDeNaissance,
    'jel-lm:components/formulaire/compte/depot': FormulaireDepot,
    'jel-lm:components/formulaire/compte/genre': FormulaireGenre,
    'jel-lm:components/formulaire/compte/identiteVerification': FormulaireIdentiteVerification,
    'jel-lm:components/formulaire/compte/limiteDepot': FormulaireLimiteDepot,
    'jel-lm:components/formulaire/compte/motDePasse': FormulaireMotDePasse,
    'jel-lm:components/formulaire/compte/nomUtilisateur': FormulaireNomUtilisateur,
    'jel-lm:components/formulaire/compte/offreBienvenue': FormulaireOffreBienvenue,
    'jel-lm:components/formulaire/compte/prenomNom': FormulairePrenomNom,
    'jel-lm:components/formulaire/compte/profession': FormulaireProfession,
    'jel-lm:components/formulaire/compte/recevoirCommunication': FormulaireRecevoirCommunication,
    'jel-lm:components/formulaire/compte/securiteMotDePasse': FormulaireSecuriteMotDePasse,
    'jel-lm:components/formulaire/compte/securiteVerification': FormulaireSecuriteVerification,
    'jel-lm:components/formulaire/compte/telephone': FormulaireTelephone,
    'jel-lm:components/formulaire/compte/televerserPieceIdentite':
      FormulaireTeleverserPieceIdentite,

    // MEDIAIMAGE (ordre alphabétique)
    'jel-lm:components/media/image/mediaImage': MediaImage,
    'jel-lm:components/media/image/mediaImageFocalPoint': MediaImageFocalPoint,
    'jel-lm:components/media/image/mediaImageLogo': MediaImageLogo,
    'jel-lm:components/media/image/mediaImageX3': MediaImageX3,

    // Compte (ordre alphabétique)
    'jel-lm:components/compte/activiteJeux': CompteActiviteJeux,
    'jel-lm:components/compte/avisBienJouer': CompteAvisBienJouer,
    'jel-lm:components/compte/casinoPrivilegesAppariement': CompteCasinoPrivilegesAppariement,
    'jel-lm:components/compte/enteteInfosPersonnelles': CompteEnteteInfosPersonnelles,
    'jel-lm:components/compte/infoPersonnelle': CompteInfoPersonnelle,
    'jel-lm:components/compte/notificationsBienJouer': CompteNotificationsBienJouer,
    'jel-lm:components/compte/limitesBienJouer': CompteLimitesBienJouer,
    'jel-lm:components/compte/titreSolde': CompteTitreSolde,

    // PROMO
    'jel-lm:components/promo/promo': Promo,
    'jel-lm:components/promo/promoDetail': PromoDetail,

    // PRODUIT
    'jel-lm:components/produit/produitCollection': ProduitCollection,

    // AUTHO
    'jel-lm:components/auth0/error': Auth0Error,
    'jel-lm:components/auth0/mfaResetPassword': Auth0MfaResetPassword,
  },
};

export default config;
